import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { getUserName, getUserInfo } from "redux/selectors";
import { STATUS_CODE } from "common/Constants";
import styled from "styled-components";
import { EditOutlined, SearchOutlined } from "@mui/icons-material";
import { Button, Col, Form, Input, message, Modal, Row, Spin, Table, Tabs } from "antd";
import COLORS from "common/Colors";
import { CALL_API } from "common/API";
import { ReactComponent as Editicon } from "../../assets/Edit_Pencil_01.svg";
import { ReactComponent as TrashDelete } from "../../assets/Trash_Full.svg";
import { ButtonFilled } from "reusableComponent/UIButtons";

const StyledButton = styled(Button)`
  width: 150px;
  color: #fff !important;
  background-color: #00685F;
  border-color: #00685F;
  border-radius: 5px;
  &:hover,
  &:focus,
  &:active,
  &.active {
    background-color: #00685F !important;
    border-color: #00685F !important;
    color: #fff !important;
  }
`;

const Styleddiv = styled.div`
  .title_button { display: flex; justify-content: space-between; }
  .job_title { font-size: 18px; font-weight: 500; }
  .jd_count { font-size: 16px; font-weight: 400; }
  .search_input { width: 176px; height: 34px; }
  .search_dropdown { display: flex; gap: 20px; }
  .ant-tabs-nav::before { border-bottom: 1px solid #e5e7eb; }
  .ant-tabs-tab { font-size: 14px; color: #6b7280; padding: 8px 0; }
  .ant-tabs-tab-active .ant-tabs-tab-btn { color: #111827 !important; font-weight: 600; }
  .ant-tabs-ink-bar { background: #111827 !important; }
  .add-btn{
    color: #fff !important;
  }
  
`;

const SaveButton = styled(Button)`
  background: #00685f !important;
  border-color: #00685f !important;
  color: #fff !important;

  &:hover,
  &:focus,
  &:active {
    background: #00524b !important;
    border-color: #00524b !important;
    color: #fff !important;
  }
`;
const CancelButton = styled(Button)`
  background: #ffffff !important;
  border-color: #000000 !important;
  color: #000000 !important;

  &:hover,
  &:focus,
  &:active {
    background: #ffffff !important;
  border-color: #000000 !important;
  color: #000000 !important;
  }
`;

const StyledTable = styled(Table)`
  padding-top: 10px;
  table { width: 100% !important; border: 1px solid #ccc; }
  .ant-table-content {
    overflow-x: auto;
    white-space: nowrap;
    color: ${COLORS.TEXT.PRIMARY};
    font-size: 14px;
  }
  .ant-table-row:nth-child(even) { background-color: #fafafa; }
  .ant-table-thead .ant-table-cell {
    font-weight: bold;
    color: ${COLORS.TEXT.PRIMARY};
    white-space: nowrap;
  }
`;


const BillingEntity = ({ userName, userInfo }) => {
  const styledIcon = { color: `${COLORS.TEXT.PRIMARY}`, fontSize: "18px" };
  const [form] = Form.useForm();
  const [modalForm] = Form.useForm();
  const [data, setData] = useState([]);
  const [searchItem, setSearchItem] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [loader, setLoader] = useState(false);
  const [activeTab, setActiveTab] = useState("billing");
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Subcontractors state
  const [subData, setSubData] = useState([]);
  const [subSearchItem, setSubSearchItem] = useState("");
  const [isSubModalOpen, setIsSubModalOpen] = useState(false);
  const [isSubEdit, setIsSubEdit] = useState(false);
  const [selectedSubRecord, setSelectedSubRecord] = useState(null);
  const [subLoader, setSubLoader] = useState(false);
  const [isSubSubmitting, setIsSubSubmitting] = useState(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [deleteType, setDeleteType] = useState("");
  const [deleteRecord, setDeleteRecord] = useState(null);
  const [subModalForm] = Form.useForm();

  const headerstyle = { fontSize: "20px", fontWeight: "bold" };

  useEffect(() => {
    getBillingEntity();
    getSubcontractors();
  }, []);

  const getBillingEntity = async () => {
    try {
      setLoader(true);
      const response = await CALL_API("insyts-billing-entity/getbillingentity", "GET");
      if (response?.code === STATUS_CODE.SUCCESS) {
        setData(response?.data || []);
      }
    } catch (error) {
      console.error("[getBillingEntity] error -->", error);
    } finally {
      setLoader(false);
    }
  };

  const filteredData = data.filter((item) =>
    Object.values(item).some((val) =>
      val?.toString().toLowerCase().includes(searchItem.toLowerCase())
    )
  );

  const getSubcontractors = async () => {
    try {
      setSubLoader(true);
      const response = await CALL_API("insyts-billing-entity/getsubcontractors", "GET");
      if (response?.code === STATUS_CODE.SUCCESS) {
        setSubData(response?.data || []);
      }
    } catch (error) {
      console.error("[getSubcontractors] error -->", error);
    } finally {
      setSubLoader(false);
    }
  };

  const filteredSubData = subData.filter((item) =>
    Object.values(item).some((val) =>
      val?.toString().toLowerCase().includes(subSearchItem.toLowerCase())
    )
  );

  const showAddSubModal = () => {
    setIsSubEdit(false);
    setSelectedSubRecord(null);
    subModalForm.resetFields();
    setIsSubModalOpen(true);
  };

  const showEditSubModal = (record) => {
    setIsSubEdit(true);
    setSelectedSubRecord(record);
    subModalForm.setFieldsValue({ subcontractor: record.subcontractor });
    setIsSubModalOpen(true);
  };

  const handleDelete = (record) => {
    setDeleteType("billing");
    setDeleteRecord(record);
    setDeleteModalOpen(true);
  };

  const handleSubDelete = (record) => {
    setDeleteType("subcontractor");
    setDeleteRecord(record);
    setDeleteModalOpen(true);
  };

  const confirmDelete = async () => {
    try {
      let response;

      if (deleteType === "billing") {
        response = await CALL_API(
          "insyts-billing-entity/deletebillingentity",
          "POST",
          {
            id: deleteRecord?.id,
            updatedby: userInfo?.userid,
            userName,
          }
        );
      } else {
        response = await CALL_API(
          "insyts-billing-entity/deletesubcontractor",
          "POST",
          {
            id: deleteRecord?.id,
            updatedby: userInfo?.userid,
            userName,
          }
        );
      }

      if (response?.code === STATUS_CODE.SUCCESS) {
        message.success(
          deleteType === "billing"
            ? "Billing Entity deleted successfully"
            : "Subcontractor deleted successfully"
        );

        deleteType === "billing"
          ? getBillingEntity()
          : getSubcontractors();

        setDeleteModalOpen(false);
      } else if (response?.message) {
        Modal.warning({
          icon: null,
          centered: true,
          content: (
            <p style={{ fontWeight: 400, fontSize: "16px", marginBottom: 0 }}>
              {response.message}
            </p>
          ),
        });
      } else {
        message.error("Delete failed");
      }
    } catch (error) {
      message.error("Error deleting record");
    }
  };

  const handleSubModalOk = () => {
    subModalForm.validateFields().then(async (values) => {
      try {
        setIsSubSubmitting(true);
        if (isSubEdit) {
          const response = await CALL_API("insyts-billing-entity/editsubcontractor", "POST", { id: selectedSubRecord?.id, ...values, updatedby: userInfo?.userid, userName });
          if (response?.code === STATUS_CODE.SUCCESS) {
            message.success(response?.message || "Subcontractor updated successfully");
            getSubcontractors();
            setIsSubModalOpen(false);
            subModalForm.resetFields();
          } else {
            message.error(response?.message || "Failed to update Subcontractor");
          }
        } else {
          const response = await CALL_API("insyts-billing-entity/addsubcontractor", "POST", { ...values, createdby: userInfo?.userid, userName });
          if (response?.code === STATUS_CODE.SUCCESS) {
            message.success(response?.message || "Subcontractor added successfully");
            getSubcontractors();
            setIsSubModalOpen(false);
            subModalForm.resetFields();
          } else {
            message.error(response?.message || "Failed to add Subcontractor");
          }
        }
      } catch (error) {
        console.error("[handleSubModalOk] error -->", error);
        message.error("Something went wrong");
      } finally {
        setIsSubSubmitting(false);
      }
    });
  };

  const subColumns = [
    { title: "Subcontractor", dataIndex: "subcontractor" },
    {
      title: "Action",
      dataIndex: "action",
      width: 200,
      align: "center",
      render: (_, record) => (
        <div className="action-icons">
          <EditOutlined
            onClick={() => showEditSubModal(record)}
            style={{
              color: "#00685F",
              cursor: "pointer",
              background: "#deefee",
              padding: "2px",
              borderRadius: "4px",
              height: "25px",
              width: "25px",
              fontSize: 18
            }}
          />
          <TrashDelete
            onClick={() => handleSubDelete(record)}
            style={{ cursor: "pointer", marginLeft: 8, backgroundColor: "#deefee" }}
          />
        </div>
      ),
    },
  ];

  const showAddModal = () => {
    setIsEdit(false);
    setSelectedRecord(null);
    modalForm.resetFields();
    setIsModalOpen(true);
  };

  const showEditModal = (record) => {
    setIsEdit(true);
    setSelectedRecord(record);
    modalForm.setFieldsValue({ name: record.name, tax: record.tax });
    setIsModalOpen(true);
  };

  const handleModalOk = () => {
    modalForm.validateFields().then(async (values) => {
      try {
        setIsSubmitting(true);
        if (isEdit) {
          const taxChanged = String(values.tax) !== String(selectedRecord?.tax);
          const response = await CALL_API("insyts-billing-entity/editbillingentity", "POST", { 
            id: selectedRecord?.id, 
            ...values, 
            editentity: taxChanged,
            updatedby: userInfo?.userid, 
            userName 
          });
          if (response?.code === STATUS_CODE.SUCCESS) {
            message.success(response?.message || "Billing Entity updated successfully");
            getBillingEntity();
            setIsModalOpen(false);
            modalForm.resetFields();
          } else {
            message.error(response?.message || "Failed to update Billing Entity");
          }
        } else {
          const response = await CALL_API("insyts-billing-entity/addbillingentity", "POST", { ...values, createdby: userInfo?.userid, userName });
          if (response?.code === STATUS_CODE.SUCCESS) {
            message.success(response?.message || "Billing Entity added successfully");
            getBillingEntity();
            setIsModalOpen(false);
            modalForm.resetFields();
          } else {
            message.error(response?.message || "Failed to add Billing Entity");
          }
        }
      } catch (error) {
        console.error("[handleModalOk] error -->", error);
        message.error("Something went wrong");
      } finally {
        setIsSubmitting(false);
      }
    });
  };

  const columns = [
    { title: "Name", dataIndex: "name" },
    {
      title: "Tax",
      dataIndex: "tax",
      render: (val) => `${val}%`,
    },
    {
      title: "Action",
      dataIndex: "action",
      width: 200,
      align: "center",
      render: (_, record) => (
        <div className="action-icons">
          <EditOutlined
            onClick={() => showEditModal(record)}
            style={{
              color: "#00685F",
              cursor: "pointer",
              background: "#deefee",
              padding: "2px",
              borderRadius: "4px",
              height: "25px",
              width: "25px",
              fontSize: 18
            }}
          />
          <TrashDelete
            onClick={() => handleDelete(record)}
            style={{ cursor: "pointer", marginLeft: 8, backgroundColor: "#deefee", color: "#00685F", }}
          />
        </div>
      ),
    },
  ];

  return (
    <Styleddiv>
      <Row className="page-title">
        <Col sm={24} md={12} style={headerstyle}>Other Entities</Col>
      </Row>
      <br />
      <Tabs
        activeKey={activeTab}
        onChange={setActiveTab}
        items={[
          {
            key: "billing",
            label: "Billing Entity",
            children: (
              <>
                <div className="title_button">
                  <p className="jd_count">List: {filteredData.length}</p>
                  <div style={{ display: "flex", gap: 16, alignItems: "center" }}>
                    <div className="search_input">
                      <Input
                        prefix={<SearchOutlined style={styledIcon} />}
                        placeholder="Search"
                        style={{ borderRadius: "24px" }}
                        value={searchItem}
                        onChange={(e) => setSearchItem(e.target.value)}
                      />
                    </div>
                    <StyledButton onClick={showAddModal}>
                      Add New
                    </StyledButton>
                  </div>
                </div>
                <br />
                <Spin spinning={loader}>
                  <StyledTable
                    columns={columns}
                    dataSource={filteredData}
                    rowKey="id"
                    pagination={false}
                  />
                </Spin>
              </>
            ),
          },
          {
            key: "subcontractors",
            label: "Subcontractors",
            children: (
              <>
                <div className="title_button">
                  <p className="jd_count">List: {filteredSubData.length}</p>
                  <div style={{ display: "flex", gap: 16, alignItems: "center" }}>
                    <div className="search_input">
                      <Input
                        prefix={<SearchOutlined style={styledIcon} />}
                        placeholder="Search"
                        style={{ borderRadius: "24px" }}
                        value={subSearchItem}
                        onChange={(e) => setSubSearchItem(e.target.value)}
                      />
                    </div>
                    <StyledButton onClick={showAddSubModal}>
                      Add New
                    </StyledButton>
                  </div>
                </div>
                <br />
                <Spin spinning={subLoader}>
                  <StyledTable
                    columns={subColumns}
                    dataSource={filteredSubData}
                    rowKey="id"
                    pagination={false}
                  />
                </Spin>
              </>
            ),
          },
        ]}
      />

      <Modal
        title={isEdit ? "Edit Billing Entity" : "Add Billing Entity"}
        open={isModalOpen}
        centered
        footer={[
          <CancelButton
            key="cancel"
            onClick={() => {
              setIsModalOpen(false);
              modalForm.resetFields();
            }}
          >
            Cancel
          </CancelButton>,
          <SaveButton
            key="save"
            onClick={handleModalOk}
            loading={isSubmitting}
          >
            {isEdit ? "Update" : "Add"}
          </SaveButton>,
        ]}
        onCancel={() => { setIsModalOpen(false); modalForm.resetFields(); setIsSubmitting(false); }}
        cancelButtonProps={{ style: { width: 130, height: 34, borderRadius: 8 }, disabled: isSubmitting }}
      >
        <Form form={modalForm} layout="vertical">
          <Form.Item name="name" label="Name" rules={[{ required: true, message: "Name is required" }]}>
            <Input />
          </Form.Item>
          <Form.Item name="tax" label="Tax (%)" rules={[
            { required: true, message: "Tax is Required" },
            {
              validator: (_, value) => {
                if (!value && value !== 0) return Promise.resolve();
                const num = parseFloat(value);
                if (isNaN(num)) return Promise.reject("Please enter a valid number.");
                if (num < 0) return Promise.reject("Value must be 0 or greater.");
                if (num > 100) return Promise.reject("Tax cannot exceed 100.");
                const str = String(value);
                if (str.includes(".") && str.split(".")[1]?.length > 2)
                  return Promise.reject("Maximum 2 decimal places allowed.");
                return Promise.resolve();
              },
            },
          ]}>
            <Input type="number" step="1" min="0" max="100" />
          </Form.Item>
        </Form>
      </Modal>

      <Modal
        title={isSubEdit ? "Edit Subcontractor" : "Add Subcontractor"}
        open={isSubModalOpen}
        centered
        footer={null}
        onCancel={() => { setIsSubModalOpen(false); subModalForm.resetFields(); setIsSubSubmitting(false); }}
        width={640}
      >
        <Form form={subModalForm} layout="vertical">
          <Form.Item name="subcontractor" label="Subcontractor" rules={[{ required: true, message: "Subcontractor is required" }]}>
            <Input placeholder="Enter subcontractor" />
          </Form.Item>
          <div style={{ display: "flex", justifyContent: "flex-end", gap: 12, marginTop: 8 }}>
            <Button
              onClick={() => { setIsSubModalOpen(false); subModalForm.resetFields(); }}
              disabled={isSubSubmitting}
              style={{ width: 100, height: 34, borderRadius: 8, border: "1px solid #000000", color: "#000000" }}
            >
              Cancel
            </Button>
            <SaveButton
              onClick={handleSubModalOk}
              loading={isSubSubmitting}
              disabled={isSubSubmitting}
            >
              Save
            </SaveButton>
          </div>
        </Form>
      </Modal>

      <Modal
        open={deleteModalOpen}
        centered
        title={null}
        footer={[
          <Button
            key="cancel"
            onClick={() => setDeleteModalOpen(false)}
            style={{
              width: 130,
              height: 34,
              borderRadius: 8,
            }}
          >
            No
          </Button>,
          <SaveButton
            key="ok"
            onClick={confirmDelete}
             style={{
              width: 130,
              height: 34,
              borderRadius: 8,
            }}
          >
            Yes
          </SaveButton>,
        ]}
        onCancel={() => setDeleteModalOpen(false)}
      >
        <p style={{ fontWeight: 400, fontSize: "16px", marginBottom: 0 }}>
          Are you sure you want to delete this{" "}
          {deleteType === "billing"
            ? "billing entity"
            : "subcontractor"}
          ?
        </p>
      </Modal>
    </Styleddiv>
  );
};

export default connect(
  (state) => ({
    userName: getUserName(state),
    userInfo: getUserInfo(state),
  })
)(BillingEntity);